/**
 * FDT/Findter Language Fix
 * Fixes product links in Findter Custom Filter & Search app to include language prefix
 * for multilingual stores using Shopify Markets.
 */
(function() {
  'use strict';

  // Get current language from various sources
  function getCurrentLanguage() {
    // 1. Try to get from PXUTheme.localization (new variable)
    if (window.PXUTheme && window.PXUTheme.localization) {
      const rootUrl = window.PXUTheme.localization.root_url;
      if (rootUrl && rootUrl !== '/') {
        const match = rootUrl.match(/^\/(\w{2})\/?$/);
        if (match) {
          return match[1];
        }
      }
      
      // If root_url is just '/', check if language differs from primary
      if (rootUrl === '/' && window.PXUTheme.localization.language) {
        const currentLang = window.PXUTheme.localization.language;
        const primaryLang = window.PXUTheme.localization.primary_language;
        if (currentLang && currentLang !== primaryLang) {
          return currentLang;
        }
      }
    }
    
    // 2. Try to get from PXUTheme.routes.root_url (legacy)
    if (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.root_url) {
      const rootUrl = window.PXUTheme.routes.root_url;
      if (rootUrl && rootUrl !== '/') {
        const match = rootUrl.match(/^\/(\w{2})\/?$/);
        if (match) {
          return match[1];
        }
      }
    }
    
    // 3. Try to get from HTML lang attribute
    const htmlLang = document.documentElement.lang;
    if (htmlLang) {
      const primaryLang = window.PXUTheme && window.PXUTheme.localization && window.PXUTheme.localization.primary_language;
      const langCode = htmlLang.split('-')[0];
      if (langCode && langCode !== primaryLang && langCode !== 'de') {
        return langCode;
      }
    }
    
    // 4. Check current URL path for language prefix
    const pathMatch = window.location.pathname.match(/^\/(\w{2})\//);
    if (pathMatch) {
      const detectedLang = pathMatch[1];
      const primaryLang = window.PXUTheme && window.PXUTheme.localization && window.PXUTheme.localization.primary_language;
      if (detectedLang !== primaryLang) {
        return detectedLang;
      }
    }
    
    return null; // No language prefix needed (default language)
  }

  // Get primary language (default shop language)
  function getPrimaryLanguage() {
    if (window.PXUTheme && window.PXUTheme.localization && window.PXUTheme.localization.primary_language) {
      return window.PXUTheme.localization.primary_language;
    }
    return 'de'; // Fallback to German as default
  }

  // Check if we need to add language prefix
  const currentLang = getCurrentLanguage();
  const primaryLang = getPrimaryLanguage();
  const isDefaultLanguage = !currentLang || currentLang === primaryLang;
  
  // If we're on default language, no fix needed
  if (isDefaultLanguage) {
    console.log('FDT Language Fix: Default language detected (' + primaryLang + '), no fix needed.');
    return;
  }

  console.log('FDT Language Fix: Current language is ' + currentLang + ', primary is ' + primaryLang);

  /**
   * Fix product links to include language prefix
   */
  function fixProductLinks() {
    // Find all product links in Findter app
    const productLinks = document.querySelectorAll('.search-filters__product-link, .fdt__product-vendor, .fdt-view-detail-button');
    
    productLinks.forEach(function(link) {
      const href = link.getAttribute('href');
      if (!href) return;
      
      // Skip if already has language prefix
      if (href.match(/^\/\w{2}\//)) {
        return;
      }
      
      // Skip if it's an absolute URL (not relative)
      if (href.startsWith('http://') || href.startsWith('https://')) {
        return;
      }
      
      // Skip if it's a mailto or tel link
      if (href.startsWith('mailto:') || href.startsWith('tel:')) {
        return;
      }
      
      // Add language prefix to the URL
      // href is like "/products/product-handle" or "/collections/vendors?q=..."
      const newHref = '/' + currentLang + href;
      link.setAttribute('href', newHref);
    });
  }

  /**
   * Fix form actions to include language prefix
   */
  function fixFormActions() {
    const forms = document.querySelectorAll('#fdt-container form, .search-filters__product-item form');
    
    forms.forEach(function(form) {
      const action = form.getAttribute('action');
      if (!action) return;
      
      // Skip if already has language prefix
      if (action.match(/^\/\w{2}\//)) {
        return;
      }
      
      // Skip if it's an absolute URL
      if (action.startsWith('http://') || action.startsWith('https://')) {
        return;
      }
      
      // Add language prefix
      const newAction = '/' + currentLang + action;
      form.setAttribute('action', newAction);
    });
  }

  /**
   * Fix redirect buttons in variant selector
   */
  function fixRedirectButtons() {
    const redirectButtons = document.querySelectorAll('[data-redirect]');
    
    redirectButtons.forEach(function(button) {
      const redirectUrl = button.getAttribute('data-redirect');
      if (!redirectUrl) return;
      
      // Skip if already has language prefix
      if (redirectUrl.match(/^\/\w{2}\//)) {
        return;
      }
      
      // Skip if it's an absolute URL
      if (redirectUrl.startsWith('http://') || redirectUrl.startsWith('https://')) {
        return;
      }
      
      // Add language prefix
      const newUrl = '/' + currentLang + redirectUrl;
      button.setAttribute('data-redirect', newUrl);
    });
  }

  /**
   * Run all fixes
   */
  function runAllFixes() {
    fixProductLinks();
    fixFormActions();
    fixRedirectButtons();
  }

  // Run immediately on current DOM
  runAllFixes();

  // Set up MutationObserver to handle dynamically loaded content
  const observer = new MutationObserver(function(mutations) {
    let shouldFix = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if added node contains Findter elements
            if (node.classList && (
              node.classList.contains('search-filters__product-item') ||
              node.classList.contains('search-filters__product-link') ||
              node.classList.contains('fdt-swatch-wrapper') ||
              node.classList.contains('fdt-selector-wrapper')
            )) {
              shouldFix = true;
            }
            
            // Check if added node contains Findter elements as children
            if (node.querySelector && (
              node.querySelector('.search-filters__product-link') ||
              node.querySelector('.fdt-swatch-wrapper') ||
              node.querySelector('[data-redirect]')
            )) {
              shouldFix = true;
            }
          }
        });
      }
    });
    
    if (shouldFix) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(runAllFixes, 10);
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also run after Findter app events
  document.addEventListener('findter-app-ready', function() {
    setTimeout(runAllFixes, 100);
  });

  document.addEventListener('findter-app-initializing', function() {
    setTimeout(runAllFixes, 100);
  });

  // Re-run on window load to catch any late-loading content
  window.addEventListener('load', function() {
    setTimeout(runAllFixes, 500);
  });

  console.log('FDT Language Fix: Initialized for language:', currentLang);
})();
